// app instance resources
export const FLAG_GETTING_APP_INSTANCE_RESOURCES =
  'FLAG_GETTING_APP_INSTANCE_RESOURCES';
export const GET_APP_INSTANCE_RESOURCES = 'GET_APP_INSTANCE_RESOURCES';
export const GET_APP_INSTANCE_RESOURCES_SUCCEEDED =
  'GET_APP_INSTANCE_RESOURCES_SUCCEEDED';
export const GET_APP_INSTANCE_RESOURCES_FAILED =
  'GET_APP_INSTANCE_RESOURCES_FAILED';

export const FLAG_POSTING_APP_INSTANCE_RESOURCE =
  'FLAG_POSTING_APP_INSTANCE_RESOURCE';
export const POST_APP_INSTANCE_RESOURCE_SUCCEEDED =
  'POST_APP_INSTANCE_RESOURCE_SUCCEEDED';
export const POST_APP_INSTANCE_RESOURCE_FAILED =
  'POST_APP_INSTANCE_RESOURCE_FAILED';
export const POST_APP_INSTANCE_RESOURCE = 'POST_APP_INSTANCE_RESOURCE';

export const FLAG_PATCHING_APP_INSTANCE_RESOURCE =
  'FLAG_PATCHING_APP_INSTANCE_RESOURCE';
export const PATCH_APP_INSTANCE_RESOURCE_SUCCEEDED =
  'PATCH_APP_INSTANCE_RESOURCE_SUCCEEDED';
export const PATCH_APP_INSTANCE_RESOURCE_FAILED =
  'PATCH_APP_INSTANCE_RESOURCE_FAILED';
export const PATCH_APP_INSTANCE_RESOURCE = 'PATCH_APP_INSTANCE_RESOURCE';

export const FLAG_DELETING_APP_INSTANCE_RESOURCE =
  'FLAG_DELETING_APP_INSTANCE_RESOURCE';
export const DELETE_APP_INSTANCE_RESOURCE_SUCCEEDED =
  'DELETE_APP_INSTANCE_RESOURCE_SUCCEEDED';
export const DELETE_APP_INSTANCE_RESOURCE_FAILED =
  'DELETE_APP_INSTANCE_RESOURCE_FAILED';
export const DELETE_APP_INSTANCE_RESOURCE = 'DELETE_APP_INSTANCE_RESOURCE';
